import { useState, createContext, useContext } from "react";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";

const FornecedoresBodyContext = createContext();

const FornecedoresBodyContextProvider = ({ children }) => {
  const { queryParams, setQueryParams } = useContext(QueryParamsContext);

  // switches
  const [contacts, setContacts] = useState(
    queryParams.guia_fornecedores_contatos === "1"
  );
  const [financialInfos, setFinancialInfos] = useState(
    queryParams.guia_fornecedores_infosfinanceiras === "1"
  );
  const [othersInfos, setOthersInfos] = useState(
    queryParams.guia_fornecedores_outrasinfos === "1"
  );
  const [integrations, setIntegrations] = useState(
    queryParams.guia_fornecedores_integracoes === "1"
  );

  return (
    <FornecedoresBodyContext.Provider
      value={{
        // switches
        contacts,
        setContacts,
        financialInfos,
        setFinancialInfos,
        othersInfos,
        setOthersInfos,
        integrations,
        setIntegrations,

        queryParams,
        setQueryParams,
      }}
    >
      {children}
    </FornecedoresBodyContext.Provider>
  );
};

export { FornecedoresBodyContext, FornecedoresBodyContextProvider };
